import { FC, ReactElement } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Checkbox } from 'dibs-elements/exports/Checkbox';
import { Input } from 'dibs-elements/exports/Input';
import { Spinner } from 'dibs-elements/exports/Spinner';
import { Button } from 'dibs-elements/exports/Button';

import styles from './styles.scss';

export type Props = {
    showAllowCallbackPrompt?: boolean;
    phoneNumber?: string;
    countryCode?: string;
    phoneCallbackEnabled?: boolean;
    error?: ReactElement | string;
    submitting?: boolean;
    setPhoneNumber: (value: string) => void;
    setCountryCode: (value: string) => void;
    setPhoneCallbackEnabled: (checked: boolean) => void;
    onSubmit: () => void;
};

const CallDealerForm: FC<Props> = ({
    showAllowCallbackPrompt,
    phoneNumber,
    countryCode,
    phoneCallbackEnabled,
    submitting,
    error,
    setPhoneCallbackEnabled,
    setPhoneNumber,
    setCountryCode,
    onSubmit,
}) => {
    const submitDisabled = submitting || !phoneNumber || !countryCode;

    return (
        <form
            className={styles.form}
            onSubmit={e => {
                e.preventDefault();
                onSubmit();
            }}
        >
            {error ? <div className={styles.error}>{error}</div> : null}
            <div className={styles.inputsRow}>
                <div className={styles.countryCode}>
                    <Input
                        dataTn="your-contry-code"
                        onChange={e => {
                            setCountryCode(e.target.value);
                        }}
                        label={
                            <FormattedMessage
                                id="dc.buyerInitiateCall.inputCountryCode"
                                defaultMessage="Country Code"
                            />
                        }
                        value={countryCode}
                        disabled={submitting}
                        leftDecorator={'+'}
                        leftDecoratorClass={styles.leftDecorator}
                    />
                </div>
                <div className={styles.phoneNumber}>
                    <Input
                        dataTn="your-number"
                        onChange={e => {
                            setPhoneNumber(e.target.value);
                        }}
                        label={
                            <FormattedMessage
                                id="dc.buyerInitiateCall.nonTradeInputPhoneNumber"
                                defaultMessage="Your number (no extensions)"
                            />
                        }
                        value={phoneNumber}
                        disabled={submitting}
                    />
                </div>
            </div>
            {showAllowCallbackPrompt ? (
                <div className={styles.allowCallbackPromptContainer}>
                    <Checkbox
                        name="showAllowCallbackPrompt"
                        onChange={setPhoneCallbackEnabled}
                        dataTn="allow-callback-prompt"
                        label={
                            <FormattedMessage
                                id="dc.buyerInitiateCall.callbackPrompt"
                                defaultMessage="Allow seller to call you back"
                            />
                        }
                        labelClass={styles.checkboxLabel}
                        checked={phoneCallbackEnabled}
                    />
                    <span className={styles.allowCallbackDetails}>
                        <FormattedMessage
                            id="dc.buyerInitiateCall.callbackDetails"
                            defaultMessage="We will not share your number with the seller."
                        />
                    </span>
                </div>
            ) : null}
            <Button
                className={styles.submit}
                disabled={submitDisabled}
                size="large"
                dataTn="connect-call"
            >
                {submitting && <Spinner dark containerClass={styles.inlineSpinner} />}
                <FormattedMessage id="dc.buyerInitiateCall.submitCall" defaultMessage="Call me" />
            </Button>
            <p className={styles.footer}>
                <FormattedMessage
                    id="dc.buyerInitiateCall.formFooter"
                    defaultMessage="International calling rates will not apply. We will not share your number with the seller."
                />
            </p>
        </form>
    );
};

export default CallDealerForm;
